// Напускането на листа „Прехвърляне" — общото `useWorksheetLeave`. Без
// промени — тихо. Ново прехвърляне: черновата се пази сама (браузър +
// сървър) → излизаме тихо, като я записваме веднага; продължава се от
// началния екран. Редакция: питаме — въпросът назовава документа и показва
// попълнените редове (`transferPreviewItems` — същите са и във въпросите за
// черновата).
import type { MutableRefObject } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import type { Product } from "../../../../api/inventory";
import { parseDecimal } from "../../components/numbers";
import { productLineItems } from "../../components/confirm/confirmPreviews";
import type { ConfirmPreviewItem } from "../../components/confirm/confirmTypes";
import { useWorksheetLeave } from "../../components/drafts/useWorksheetLeave";
import type { TransferLineDraft } from "./transferWorksheetShared";

// „Продукт — количество" на попълнените редове
export const transferPreviewItems = (lines: TransferLineDraft[], products: Product[]): ConfirmPreviewItem[] => {
  const productById = new Map(products.map((product) => [product.id, product]));
  const filled = lines
    .map((line) => ({ productId: line.productId, quantity: parseDecimal(line.quantity) }))
    .filter((line) => line.quantity > 0);
  return productLineItems(filled, productById);
};

type Params = {
  mode: "new" | "edit";
  lines: TransferLineDraft[];
  products: Product[];
  dirtyRef: MutableRefObject<boolean>;
  // нов документ: черновата се записва веднага и листът излиза тихо
  flushDraft?: () => Promise<void>;
  onRegisterLeaveGuard?: (guard: ((proceed: () => void) => void) | null) => void;
};

export const useTransferLeave = ({ mode, lines, products, dirtyRef, flushDraft, onRegisterLeaveGuard }: Params) => {
  const { t } = useTranslation();
  const { transferId } = useParams();
  return useWorksheetLeave({
    mode,
    dirtyRef,
    flushDraft,
    onRegisterLeaveGuard,
    describeUnsaved: () => ({
      document:
        mode === "new"
          ? t("inventoryPage.cfmDocNewTransfer")
          : t("inventoryPage.cfmDocEditTransfer", { number: transferId ?? "" }),
      isNew: mode === "new",
      items: transferPreviewItems(lines, products),
    }),
  });
};
